<template>
    <div :class="['pwrapper', {'placeFlag': placeFlagState}]">

        <div ref="loadmask" class="loadmask">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 158 92" style="enable-background:new 0 0 158 92;" xml:space="preserve">
                    <g>
                        <path class="st1" style="fill:#fff;" d="M126.2,62.8c0.1,0.3-1.1,1.6-1.4,1.8c-0.3,0.2-1,1.6-1.1,2c-0.1,0.4-0.5,2-0.2,2.3c0.3,0.3,0.2,1-0.1,0.9   c-0.3-0.1-1.5-1.2-1.5-1.2v-1.1c0-0.5,1.2-2.4,1.2-2.4s1.1-1.4,1.4-1.4C124.6,63.8,126.2,62.5,126.2,62.8 M91.8,66.2   c-0.2,0.7-0.7,1.3-0.7,1.6c0.1,0.2,0.1,2.3,0,2.4c0,0-2.1,1.7-2.6,1.8c-0.4,0.1-1.2-0.4-1.7-0.6c-0.5-0.2,0-1.2,0-1.2   s0.6-2.6,0.4-3c-0.2-0.3,2.6-2.4,3.2-2.5c0.6-0.1,0.1-1.7,0-3c-0.1-1.3,0.7-1,0.7-1s0.2,2.1,0.7,2.8C92.3,64.1,92.1,65.5,91.8,66.2    M67.4,72.8c0,0,0.4,1.4,0.4,1.5c0,0.1-1-0.4-1.3-0.5c-0.2-0.1-1-0.4-1-0.4s0.9-0.7,0.9-0.9c0-0.2,0.7-1,0.7-1s0.6-0.1,0.4,0   C67.4,71.7,67.4,72.8,67.4,72.8 M62.1,71.4l-0.1,0.8l-0.4,0.8l-1.1,1l-0.6,0.7c0,0-0.2-0.2-0.6,0.1c-0.4,0.3-1.6,1.1-1.6,1.1   s-0.6-0.1,0-0.6c0.1-0.1,1.3-1.1,1.3-1.1l0.7-0.3c0,0,1.1-1.1,1.2-1.1C60.9,72.8,62.1,71.4,62.1,71.4 M140.6,76.9   c-0.9-2.4-2.1-2.6-3.2-4.9c-1.2-2.2-1.2-1.5-3.4-4.6c-2.2-3.1-1.9-2.2-3.8-4.9C128.3,60,128,60,128,60s-3.5,1.8-4,1.9   c-0.4,0.1-2.6,2.8-3.8,4c-1.2,1.2-1.9,0.1-1.9,0.1s-2.1-2.8-2.9-3.4c-0.9-0.6-2.2-2.6-3.1-3.4c-0.9-0.7-1.3-2.9-1.9-3.2   c-0.6-0.3-3.1-3.4-3.7-4.3c-0.6-0.9-1.3-1.3-1.8-1.9c-0.4-0.6-2.4-2.2-3.1-2.5c-0.7-0.3-1.8-1.8-2.6-1.6c-0.9,0.1-1.2,0-1.2,0   s-1.3,0.9-1.9,1.6c-0.6,0.7-2.5,2.6-2.8,3.1c-0.3,0.4-1,1.8-1,1.8s-3.4,2.2-3.7,2.6c-0.3,0.4-0.7,1-1.2,1.3   c-0.4,0.3-3.1,2.4-3.5,2.4c-0.4,0-0.9,1.6-1.6,2.2c-0.7,0.6-0.3,1-0.9,1.5c-0.6,0.4-3.2,2.4-3.8,2.2c-0.6-0.1-1.2,1.5-1.2,1.5   l-1.2,2.6c0,0-1.8-1-1.8-1.5c0-0.4-2.1-2.1-2.1-2.1s-1.8-0.6-2.2-0.6c-0.4,0-1.2,0.7-2.1,1c-0.9,0.3,0,0-0.9,1.2   c-0.9,1.2-1.6,1.2-2.4,1.3c-0.7,0.1-1.3,1-1.3,1s-0.6,1.3-1.3,2.2c-0.7,0.9-1.5,1.2-1.5,1.2l-1.5,0.9c0,0-1,1-1.5,1   c-0.4,0-3.8,3.9-3.8,5.3c0,0.9,3-1,3-1l2.1-0.6c0,0,2.4,0.3,2.8,0.3c0.4,0,4.3,0.7,5.3,1c1,0.3,1.2-1.7,1-2.3   c-0.2-0.6,0.7-1.9,0.9-2c0.2-0.1,0.4,0.1,0.6-0.5c0.2-0.6-0.3-1.8-0.2-2c0.1-0.3,0.3-1.5,0.3-1.5s0.7,0.2,1.3,0.6   c0.7,0.4,0.2-0.7,0.2-1c0-0.4-0.2-0.9-0.4-1.3c-0.2-0.4,0.7-1.5,0.8-1.8c0.1-0.3,0.3,0.4,0.4,0.7c0.1,0.3,1.5,1.6,1.5,1.6l0.7,1.4   c0,0,0.2,1.3,0.3,1.6c0.1,0.3,0.2-0.9,0.4-1.7c0.2-0.8-0.4-0.8-0.7-1.5c-0.3-0.7-0.3-0.8-0.3-0.8s1.9,1.4,2.3,2   c0.4,0.6,1.1,1.4,0.9,2.5c-0.2,1,0.4,1.9,0.6,2.5c0.1,0.6,1,2.4,0.7,2.9c-0.3,0.6,2.4,0.4,2.4,0.4s5.8-0.2,6.1-0.2   c0.2,0,2.7,0.6,3.9,0.7c1.2,0.2,1.8-0.7,1.8-0.7s0.1-1.3,0.3-1.7c0.2-0.4,1.3-2.6,1.8-3c0.5-0.4,4-4.1,3.2-4.9   c-0.7-0.8,0-2-0.6-3.4c-0.6-1.4,0.3-2.3,0.6-2.7c0.3-0.4,0.8-2,0.7-2.3s-1.1-2.5-1-3c0.1-0.5-0.3-2.4-0.5-2.6   c-0.2-0.2,1.7-2.3,1.9-2.4c0.2-0.1,1.3-2.8,1.4-2.8c0.2,0,0.9,0.6,1.3,1c0.4,0.4,0.8,1.4,0.9,2c0.1,0.6,0.3,1.5,0.5,2.8   c0.2,1.2,1.2,1.9,1.2,2.1c0,0.2,1.1,2.5,1.1,2.5l0.3-1.1c0,0-0.4-1.4-0.5-2.4c-0.1-0.9-0.2-1.9-0.3-2.3c-0.1-0.4,1.1-1.4,1.1-1.4   s0.4,0.9,0.6,1.4c0.1,0.5,0.7,1,0.7,1.2c0.1,0.2,0.2,1.2,0.3,1.9c0.1,0.7,0.5,1.3,0.9,1.7c0.4,0.4,0.4,1.1,0.6,1.6   c0.2,0.5,1,2.2,1,2.6c0,0.4,0.8,3.1,0.9,3.5c0.2,0.4,0.8,1,0.8,1s-0.2-1.2-0.3-2.4c-0.1-1.2,0.1-0.6,0-1.4   c-0.1-0.8-0.3-1.7-0.3-1.9c0-0.2-1.3-1.7-1.5-2.3c-0.2-0.6,1.5,0.3,1.7,0.5c0.2,0.2,1.2,1.2,2,2.2c0.8,1,1.8,1.6,3.4,3.8   c1.7,2.2,0.4,0.9,0.4,2c0,1.1,2.4,2.2,3.2,3.1c0.8,0.9,1.4,3.2,1.7,5.3c0.2,2.1,2,1.1,2,1.1s2.1,0.1,2.8,0.1c0.7,0,3-0.1,3-0.1   s0.3-1.1-0.1-1.4c-0.4-0.3-1.4-3.1-1.7-4c-0.2-0.9,0-1.4,0.3-1.9c0.3-0.4,0.8-1.9,0.8-1.9s-0.1-2.3,0.7-3.1c0.8-0.8,1,0.1,1,0.1   s0.8,0.6,0.9,0.9c0.1,0.3,1.1,1.7,1.1,1.7s0.7,1.9,0.4,2.3c-0.2,0.4,1.2,1.5,1.3,2c0.1,0.4,1.1,1,1.1,1s-0.3-1.2-0.7-2.8   c-0.3-1.5,0.3,0.7,0.9,1.4c0.6,0.8,2.1,1.8,2.3,2.1c0.2,0.3,1.7,2.5,2.3,2.6c0.7,0.1,1.2,1.4,1.2,1.4S141.5,79.3,140.6,76.9"/>
                    </g>
                </svg>
                <h1>Loading...</h1>
            </div>
        </div>

        <div ref="progress" class="progress"></div>
        <div class="top-left">
            <a target="_blank" href="https://lovattsmagazines.com.au/collections/kit-magazine-subscription">
                <img :src="`${rootDomain}/images/kit-mountain-tag.svg`">
                <img :src="`${rootDomain}/images/kit.svg`" class="logo">
            </a>
        </div>
        <div class="outline br"></div>
        <div class="outline bl"></div>

        <div :class="['popupBg', {'popupIsOpen': popupIsOpen}]"></div>

        <button 
            class="submit-btn initial" 
            v-show="loaded && !popupIsOpen && !placeFlagState && !congrats" 
            @click="openPopup"
        >
            MAKE YOUR OWN 'I WILL' PLEDGE
        </button>

        <div class="congrats" v-show="congrats">
            <div class="border">
                <h2>Congratulations!</h2>
                <p>Share this page with your friends:</p>
                <p>https://kitmagazine.com.au/i-will/</p>
                <button class="btn btn-primary" @click="copyLink">COPY LINK</button>
            </div>
        </div>
    
        <section 
            :class="['text-input', {
                'popupIsOpen': popupIsOpen, 
                'placeFlag': placeFlagState, 
                'loaded': loaded
            }]" 
            ref="textInput"
        >
            <div v-show="introVisible" class="intro">
                <h1 class="intro-header">The mountain whispers to you: Be ready. <br>You whisper back:</h1>
                <div class="bigquote">
                    <span>I WILL</span> 
                    <div class="input-container">
                        <textra 
                            :data='textraArr' 
                            :timer="4" 
                            filter="top-bottom" 
                            :infinite="true" 
                        />
                    </div>
                </div>

                <div class="controlhelp">
                    <span v-show="deviceType === 'pc'">CLICK + DRAG TO LOOK AROUND</span>
                    <span v-show="deviceType === 'mobile'">SLIDE TO LOOK AROUND</span>
                </div>

            </div>

            <div class="controlhelp flag" v-show="placeFlagState && deviceType === 'pc'">
                USE THE ARROW KEYS TO LOOK AROUND<br>
                LEFT CLICK TO SET THE FLAG'S LOCATION
            </div>

            <div class="controlhelp flag" v-show="placeFlagState && deviceType === 'mobile'">
                SLIDE TO LOOK AROUND<br>
                TAP TO SET YOUR FLAGS POSITION
            </div>

            <div class="popup" v-show="popupIsOpen">

                <div class="field">
                    <h2>Make your pledge for the chance to win</h2>
                </div>

                <div class="field">
                    <label>I WILL</label> 
                    <div :class="['input-container',{'error': $v.inputText.$error}]">
                        <input type="text" v-model="inputText" ref="pledgeInput" autocomplete="off">
                    </div>
                    <!-- <div class="error" v-if="!$v.inputText.required">Field is required</div> -->
                    <!-- <div class="error" v-if="!$v.inputText.minLength">Pledge must have at least {{$v.inputText.$params.minLength.min}} letters.</div> -->
                </div>

                <div class="field">
                    <label>NAME:</label> 
                    <div :class="['input-container',{'error': $v.name.$error}]">
                        <input type="text" name="name" id="name" v-model="name">
                    </div>
                    <!-- <div class="error" v-if="!$v.name.required">Field is required</div> -->
                    <!-- <div class="error" v-if="!$v.name.minLength">Name must have at least {{$v.name.$params.minLength.min}} letters.</div> -->
                </div>

                <div class="field age">
                    <label>AGE:</label> 
                    <div :class="['input-container',{'error': $v.age.$error}]">
                        <input type="number" name="age" id="age" v-model="age">
                    </div>
                    <!-- <div class="error" v-if="!$v.age.required">Field is required</div> -->
                </div>

                <div class="field state">
                    <label>STATE:</label> 
                    <div :class="['input-container',{'error': $v.state.$error}]">
                        <select v-model="state">
                            <option disabled value=""></option>
                            <option disabled value="">AUSTRALIA</option>
                            <option value="ACT">ACT</option>
                            <option value="NSW">NSW</option>
                            <option value="NT">NT</option>
                            <option value="QLD">QLD</option>
                            <option value="SA">SA</option>
                            <option value="TAS">TAS</option>
                            <option value="VIC">VIC</option>
                            <option value="WA">WA</option>
                            <option disabled value="">NEW ZEALAND</option>
                            <option value="NZ-AUK">NZ-AUK</option>
                            <option value="NZ-BOP">NZ-BOP</option>
                            <option value="NZ-CAN">NZ-CAN</option>
                            <option value="NZ-GIS">NZ-GIS</option>
                            <option value="NZ-HKB">NZ-HKB</option>
                            <option value="NZ-MBH">NZ-MBH</option>
                            <option value="NZ-MWT">NZ-MWT</option>
                            <option value="NZ-NSN">NZ-NSN</option>
                            <option value="NZ-NTL">NZ-NTL</option>
                            <option value="NZ-OTA">NZ-OTA</option>
                            <option value="NZ-STL">NZ-STL</option>
                            <option value="NZ-TAS">NZ-TAS</option>
                            <option value="NZ-TKI">NZ-TKI</option>
                            <option value="NZ-WKO">NZ-WKO</option>
                            <option value="NZ-WGN">NZ-WGN</option>
                            <option value="NZ-WTC">NZ-WTC</option>
                            <option value="NZ-CIT">NZ-CIT</option>
                        </select>
                    </div>
                    <!-- <div class="error" v-if="!$v.state.required">Field is required</div> -->
                </div>

                <div class="field">
                    <label>EMAIL:</label> 
                    <div :class="['input-container',{'error': $v.email.$error}]">
                        <input type="email" v-model="email">
                    </div>
                    <!-- <div class="error" v-if="!$v.email.required">Field is required</div> -->
                </div>

                <div class="field switch-field">
                    <span class="switch-text">Does this email belong to your parents?</span>

                    <div class="switch">
                        <input type="radio" class="switch-input" v-model="parentsEmail" value="yes" id="yes">
                        <label for="yes" class="switch-label switch-label-off">MINE</label>
                        <input type="radio" class="switch-input" v-model="parentsEmail" value="no" id="no" checked>
                        <label for="no" class="switch-label switch-label-on">PARENTS</label>
                        <span class="switch-selection"></span>
                    </div>
                </div>

                <div class="field colors">
                    <label>FLAG COLOUR:</label> 
                    <div class="input-container">
                        <input type="radio" class="color-input" v-model="color" value="blue" id="blue" checked>
                        <label for="blue" class="color-label"></label>
                        <input type="radio" class="color-input" v-model="color" value="red" id="red">
                        <label for="red" class="color-label"></label>
                        <input type="radio" class="color-input" v-model="color" value="orange" id="orange">
                        <label for="orange" class="color-label"></label>
                        <input type="radio" class="color-input" v-model="color" value="pink" id="pink">
                        <label for="pink" class="color-label"></label>
                        <input type="radio" class="color-input" v-model="color" value="green" id="green">
                        <label for="green" class="color-label"></label>
                    </div>
                </div>

                <div class="field text-btm">
                    <p>Place your flag amongst the mountains for your chance to win 1 of 4 weekly prize packs.</p>
                </div>

                <div style="display: block;" :class="['field consent', {'error': $v.consent.$error}]">
                    <input type="checkbox" v-model="consent" autocomplete="off" style="display: inline-block;width: 26px;pointer-events: auto;">
                    I agree to the <a href="https://kitmagazine.com.au/wp-content/uploads/2020/05/Terms-Cond-KIT-Mountain_FINAL.pdf" target="_blank" style="text-decoration: underline;color: #fff;">terms and conditions</a>
                </div>

                <div class="submit-btns">
                    <button 
                        class="submit-btn back" 
                        v-show="popupIsOpen" 
                        @click="popupIsOpen = false"
                    >
                        BACK
                    </button>

                    <button 
                        type="submit"
                        class="submit-btn" 
                        v-show="popupIsOpen" 
                        @click.prevent="enterPlaceFlagMode"
                    >
                        PLACE YOUR FLAG
                    </button>                    
                </div>

            </div>

        </section>

        <div :class="['pcontainer', {'placing': placeFlagState}]" ref="container">

            <div class="mover" ref="mover">
                <img ref="imageCursor" :src="`${rootDomain}/images/flags/flag-red.png`" alt="">
            </div>

        </div>

        <canvas ref="testc" class="testc"></canvas>
        
    </div>
</template>

<script>

import * as THREE from 'three/build/three.module.js';
import * as PANOLENS from 'panolens/build/panolens.js'
import BOUNDS from './boundingPolys.js'
import axios from 'axios'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

export default {

    data() {
        return {
            panorama: null,
            bounds1: null,
            bounds2: null,
            bounds3: null,
            loaded: false,
            viewer: null,
            popupIsOpen:false,
            introVisible:true,
            placeFlagState: false,
            congrats: false,
            consent: false,
            textraArr: [],
            inputText: '',
            submitStatus: 'PENDING',
            name: '',
            email: '',
            age: '',
            state: '',
            parentsEmail: 'no',
            color: 'blue',
            imageCursor: '',
            // rootDomain: 'https://kitmagazine.com.au/wp-content/themes/kit-child-theme/mountain',
            rootDomain: 'https://kitmagazine.com.au/wp-content/themes/kit-child-theme/mountain',
            deviceType: 'pc',
            infospots: [],
        }
    },

    validations: {
        inputText: { required },
        name: { required, minLength: minLength(2) },
        age: { required },
        email: { required, email },
        parentsEmail: { required },
        state: { required },
        color: { required },
        consent: { sameAs: val => val === true },
    },

    created() {
        if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            this.deviceType = 'mobile'
        }
        
    },

    mounted() {
        this.panorama = new PANOLENS.ImagePanorama( this.rootDomain+'/images/textures/Dufourspitze2.jpg' )
        this.viewer = new PANOLENS.Viewer({
            container: this.$refs.container,
            output: 'console',
            controlBar: false,
        })
        
        const colors = ['orange', 'red', 'blue', 'pink', 'green']
        const imageCount = colors.length
        // preload textures
        let images = []
        let imagesLoaded = 0

        try {
            const textureLoader = new THREE.TextureLoader()

            for (let i = 0; i< colors.length; i++) {

                var text = textureLoader.load(`${this.rootDomain}/images/flags/flag-${colors[i]}.png`, () => {
                    console.log(text)
                    // imagesLoaded++
                    // if (imagesLoaded == imageCount) 
                        // this.$nextTick(() => this.init())
                })
            }

        }
        catch(err) {
            console.log(err)
        }


        // console.log(PANOLENS)
        // console.log(PANOLENS.Utils.TextureLoader)

        // for (let i = 0; i< colors.length; i++) {
        //     PANOLENS.Utils.TextureLoader.load( `${this.rootDomain}/images/flags/flag-${colors[i]}.png`, () => {
        //         console.log('loaded')
        //         imagesLoaded++
        //         if (imagesLoaded == imageCount) 
                    this.$nextTick(() => this.init())
        //     })
        // }
    },

    methods: {

        init() {
            this.panorama.addEventListener( 'progress', this.onProgress )
            this.panorama.addEventListener( 'enter', this.onEnter )

            this.viewer.OrbitControls.noZoom = true
            this.viewer.getCamera().fov = 35
            this.viewer.getControl().momentumScalingFactor *= 0.4
            this.viewer.getCamera().updateProjectionMatrix()
            
            this.onPlaceFlag.bind(this)
            this.onFlagMove.bind(this)
            
            this.$refs.container.addEventListener('click', () => {
                this.panorama.toggleInfospotVisibility(true)
            })
            this.$refs.container.addEventListener('touchend', () => {
                this.panorama.toggleInfospotVisibility(true)
            })
            this.$refs.container.addEventListener('mousedown', () => {            
                this.introVisible = false
            })
            this.$refs.container.addEventListener('touchstart', (e) => {       
                e.preventDefault()     
                this.introVisible = false
            })

            this.viewer.camera.position.set(100, 10, 50);
            this.viewer.add(this.panorama)
            this.addAllFlags()
        },

        addAllFlags() {
            // get local storage items
            let localKeys = Object.keys(localStorage)

            for (let i = 0; i < localKeys.length; i++) {
                
                if (localKeys[i].indexOf('flag_') !== -1) {
                    let meta = JSON.parse(localStorage.getItem(localKeys[i]))
                    if (meta) {
                        this.addInfospot({
                            id: meta.id,
                            x: meta.x_pos,
                            y: meta.y_pos, 
                            z: meta.z_pos,
                            text: meta.text,
                            myFlag: true,
                            distance: meta.distance,
                            color: meta.color,   
                        })
                    }
                }             
            }

            // get all wp comments
            axios.get(
                wpApiSettings.root+'wp/v2/comments', 
                { post: 927 }, 
                { headers: { 'X-WP-Nonce': wpApiSettings.nonce } 
            })
            .then(res => {
                let data = res.data
                console.log(res.data)
                data.forEach(is => {
                    if (
                        is.status === 'approved' && 
                        is.content.rendered.indexOf('| meta:') !== -1 &&
                        typeof this.infospots.find(x => x.id === is.id) === 'undefined'
                    ) {
                        // lame hack because the wordpress rest api doesn't allow 
                        // anonymous users to post meta data in comments
                        let textRaw = is.content.rendered.replace(/(<([^>]+)>)/ig, '')
                        let split = textRaw.split('| meta:')
                        let content = split[0].trim()
                        let json = split[1]
                        json = json.split('&#8220;').join('"').split('&#8221;').join('"').split('&#8243;').join('"')                    
                        let meta = JSON.parse(json.trim())
                        console.log(content, meta)
                        if (meta && typeof content !== "undefined") {
                            setTimeout( () => {
                                this.addInfospot({
                                    x: meta.x_pos,
                                    y: meta.y_pos, 
                                    z: meta.z_pos,
                                    text: this.infoTextHTML(content, is.author_name, meta.state),
                                    textRaw: content,
                                    color: meta.color,
                                    distance: meta.distance,
                                    age: meta.age,
                                })
                            }, 100)
                        }
                    }
                })

                let shuffled = this.shuffle(this.infospots)
                shuffled.forEach(is => { 
                    if (is.textRaw)
                        this.textraArr.push(is.textRaw + '.') 
                })
            })
            .catch(err => {
                console.log(err.response)
            })
        },

        fallbackCopyTextToClipboard(text) {
            var textArea = document.createElement("textarea")
            textArea.value = text
            
            // Avoid scrolling to bottom
            textArea.style.top = "0"
            textArea.style.left = "0"
            textArea.style.position = "fixed"

            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()

            try {
                var successful = document.execCommand('copy')
                var msg = successful ? 'successful' : 'unsuccessful'
                console.log('Fallback: Copying text command was ' + msg)
            } 
            catch (err) {
                console.error('Fallback: Oops, unable to copy', err)
            }

            document.body.removeChild(textArea);
        },

        copyTextToClipboard(text) {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text)
                return
            }
            navigator.clipboard.writeText(text).then(() => {
                console.log('Async: Copying to clipboard was successful!')
            }, (err) => {
                console.error('Async: Could not copy text: ', err)
            })
        },

        copyLink() {
            this.congrats = false
            this.copyTextToClipboard('https://kitmagazine.com.au/i-will/')
        },

        infoTextHTML(text, name, state) {            
            // strip tags
            text = text.replace(/(<([^>]+)>)/ig, '')
            text = text.trim()
            return `<span>I will ${text}.</span><div><span>${name}</span><span>${state}</span></div>`
        },

        vectorsToHUD(boundingPolyArr) {
            const canvas = this.viewer.renderer.domElement
            var widthHalf = 0.5 * canvas.width
            var heightHalf = 0.5 * canvas.height
            let poly2d = []

            for (let i = 0; i < boundingPolyArr.length; i++) {

                const vector = new THREE.Vector3(boundingPolyArr[i][0], boundingPolyArr[i][1], boundingPolyArr[i][2]);

                this.panorama.updateMatrixWorld()
                vector.applyMatrix4(this.panorama.matrixWorld)

                // // map to normalized device coordinate (NDC) space
                vector.project( this.viewer.camera )

                // // map to 2D screen space
                vector.x = ( vector.x * widthHalf ) + widthHalf
                vector.y = - ( vector.y * heightHalf ) + heightHalf

                // detect which points are in front of camera
                if (vector.z < 1 && 
                    vector.x >= -5 && 
                    vector.x <= canvas.width  && 
                    vector.y >= -100 && 
                    vector.y <= canvas.height + 100
                ) {    
                    poly2d.push([vector.x, vector.y])
                }
            }

            if (poly2d.length) {
                // sort by x pos
                poly2d.sort((a,b) => a[0]-b[0])

                // order points to x & y
                poly2d.splice( 0, 0, [ 0, canvas.height] ) 
                poly2d.splice( 1, 0, [ 0, poly2d[1][1] ] ) 
                poly2d.push( [ canvas.width, poly2d[poly2d.length-1][1] ] ) 
                poly2d.push( [canvas.width, canvas.height] )

                return poly2d
            }

            return false
        },

        // for testing purposes
        // drawBoundingBox() {
        //     const canvas = this.viewer.renderer.domElement
        //     let testc = this.$refs.testc
        //     testc.width = canvas.width
        //     testc.height = canvas.height
        //     let ctx = testc.getContext("2d")

        //     ctx.clearRect(0,0,testc.width, testc.height)

        //     ctx.beginPath()
        //     ctx.fillStyle = 'rgba(0,0,0,0.4)'
        //     ctx.moveTo(0, canvas.height)

        //     for (let i = 1; i < this.bounds1.length; i++)      
        //         ctx.lineTo(this.bounds1[i][0], this.bounds1[i][1])      

        //     ctx.stroke()
        //     ctx.fill()
        //     ctx.moveTo(0, canvas.height)
        //     ctx.closePath()

        //     ctx.beginPath()
        //     ctx.fillStyle = 'rgba(0,0,0,0.2)'
        //     ctx.moveTo(0, canvas.height)

        //     for (let i = 0; i < this.bounds2.length; i++) 
        //         ctx.lineTo(this.bounds2[i][0], this.bounds2[i][1])
            
        //     ctx.moveTo(0, canvas.height)
        //     ctx.stroke()
        //     ctx.fill()
        //     ctx.closePath()

        //     ctx.beginPath()
        //     ctx.fillStyle = 'rgba(0,0,0,0.2)'
        //     ctx.moveTo(0, canvas.height)

        //     for (let i = 0; i < this.bounds3.length; i++) 
        //         ctx.lineTo(this.bounds3[i][0], this.bounds3[i][1])
            
        //     ctx.moveTo(0, canvas.height)
        //     ctx.stroke()
        //     ctx.fill()
        //     ctx.closePath()
        // },

        enterPlaceFlagMode(e) {
            e.preventDefault()
            this.$v.$touch()

            console.log(this)

            if (!this.$v.$invalid) {
                this.popupIsOpen = false
                this.placeFlagState = true
                this.imageCursor = `${this.rootDomain}/images/flags/flag-${this.color}.png`
                this.$refs.imageCursor.src = this.imageCursor

                this.setBounds()

                document.documentElement.addEventListener('mousemove', this.onFlagMove)
                document.addEventListener('keydown', this.clearBounds)
                document.addEventListener('mousedown', this.clearBounds)
                document.addEventListener('mouseup', this.setBounds)
                document.addEventListener('keyup', this.setBounds)

                this.panorama.addEventListener('click', this.onPlaceFlag)
                this.panorama.addEventListener('touchend', this.onPlaceFlag)
            }
            return false
        },  
        
        clearBounds() {
            this.bounds1 = []
            this.bounds2 = []
            this.bounds3 = []
            // this.drawBoundingBox()
        },

        setBounds() {
            this.bounds1 = this.vectorsToHUD(BOUNDS.boundingPoly1)
            this.bounds2 = this.vectorsToHUD(BOUNDS.boundingPoly2)
            this.bounds3 = this.vectorsToHUD(BOUNDS.boundingPoly3)   
            // this.drawBoundingBox()
    
            setTimeout(() => {
                this.bounds1 = this.vectorsToHUD(BOUNDS.boundingPoly1)
                this.bounds2 = this.vectorsToHUD(BOUNDS.boundingPoly2)
                this.bounds3 = this.vectorsToHUD(BOUNDS.boundingPoly3)   
                // this.drawBoundingBox()
            }, 500)
            setTimeout(() => {
                this.bounds1 = this.vectorsToHUD(BOUNDS.boundingPoly1)
                this.bounds2 = this.vectorsToHUD(BOUNDS.boundingPoly2)
                this.bounds3 = this.vectorsToHUD(BOUNDS.boundingPoly3)   
                // this.drawBoundingBox()
            }, 1000)
        },

        onFlagMove(e) {
            const mouse = this.getMousePos(e)

            let y = e.clientY
            let x = e.clientX
            
            if (this.pointInPolygon(mouse, this.bounds1)) {
                if (this.$refs.imageCursor.src === `${this.rootDomain}/images/no.png`)
                    this.$refs.imageCursor.src = this.imageCursor
                this.$refs.mover.style.width = '32px'
                this.$refs.mover.style.height = '32px'
            }
            else if (this.pointInPolygon(mouse, this.bounds3)) {
                if (this.$refs.imageCursor.src === `${this.rootDomain}/images/no.png`)
                    this.$refs.imageCursor.src = this.imageCursor
                this.$refs.mover.style.width = '24px'
                this.$refs.mover.style.height = '24px'
                y -= 5
            }
            else if (this.pointInPolygon(mouse, this.bounds2)) {
                if (this.$refs.imageCursor.src === `${this.rootDomain}/images/no.png`)
                    this.$refs.imageCursor.src = this.imageCursor
                this.$refs.mover.style.width = '16px'
                this.$refs.mover.style.height = '16px'
                y -= 10
            }
            else {
                if (this.$refs.imageCursor.src === this.imageCursor)
                    this.$refs.imageCursor.src = `${this.rootDomain}/images/no.png`
                this.$refs.mover.style.width = '16px'
                this.$refs.mover.style.height = '16px'
            }

            document.documentElement.style.setProperty('--mouse-x', x + "px");
            document.documentElement.style.setProperty('--mouse-y', y + "px");
        },

        onPlaceFlag(e) {
            const mouse = this.getMousePos(e.mouseEvent) 
            this.bounds1 = this.vectorsToHUD(BOUNDS.boundingPoly1)
            this.bounds2 = this.vectorsToHUD(BOUNDS.boundingPoly2)
            this.bounds3 = this.vectorsToHUD(BOUNDS.boundingPoly3)   

            if (this.pointInPolygon(mouse, this.bounds1)) 
                this.placeFlag('foreground')            
            else if (this.pointInPolygon(mouse, this.bounds3)) 
                this.placeFlag('midground')
            else if (this.pointInPolygon(mouse, this.bounds2)) 
                this.placeFlag('background')            
            else 
                return console.log('sky')

            this.panorama.toggleInfospotVisibility(true)
        },

        placeFlag(distance) {
            const intersects = this.viewer.raycaster.intersectObject(this.panorama, true)
            const point = intersects[0].point.clone()
            const converter = new THREE.Vector3(-1, 1, 1)
            const world = this.panorama.getWorldPosition(new THREE.Vector3())
            point.sub(world).multiply(converter)
            let meta = {
                age: this.age,
                state: this.state,
                x_pos: point.x,
                y_pos: point.y,
                z_pos: point.z,
                state: this.state,
                color: this.color,   
                distance: distance,
                parentsEmail: this.parentsEmail
            }
            
            let split = this.name.split(' ')
            let lastName = ''

            if (split.length > 1) {
                lastName = split[1].substring(0, 1).toUpperCase() + '.'
                this.name = split[0] + ' ' + lastName
            }

            // wpApiSettings is created in the wp_localize_script function
            
            axios.post(wpApiSettings.root+'wp/v2/comments', {
                post: 927,
                author_name: this.name,
                author_email: this.email,
                content: this.inputText + ' | meta:' + JSON.stringify(meta),
            }, { headers: { 'X-WP-Nonce': wpApiSettings.nonce } 
            })
            .then(res => {
                // on success save to local storage
                if (res.data.id) {
                    meta.id = res.data.id
                    meta.text = this.infoTextHTML(this.inputText, this.name, this.state)
                    localStorage.setItem('flag_' + meta.id, JSON.stringify(meta))
                    
                    // render infospot
                    this.addInfospot({
                        x: point.x,
                        y: point.y, 
                        z: point.z,
                        text: meta.text,
                        myFlag: true,
                        distance: distance,
                        color: this.color,   
                    })

                    // klaviyo tracking
                    _learnq.push(['identify', {
                        '$email' : this.email,
                        '$first_name' : this.name,
                    }])

                    _learnq.push(['track', 'Made a pledge KIT website', {
                        'age' : this.age,
                        'state' : this.state,
                        'pledge' : this.inputText,
                        'consent' : this.consent,
                        'parentsEmail' : this.parentsEmail,
                    }])

                    // FB TRACKING
                    fbq('track', 'SubmitApplication')

                    // clear event listeners
                    document.documentElement.removeEventListener('mousemove', this.onFlagMove)
                    this.panorama.removeEventListener('click', this.onPlaceFlag)
                    document.removeEventListener('keydown', this.clearBounds)
                    document.removeEventListener('mousedown', this.clearBounds)
                    document.removeEventListener('mouseup', this.setBounds)
                    document.removeEventListener('keyup', this.setBounds)

                    // state
                    this.placeFlagState = false
                    this.congrats = true

                    console.log('success')
                }
            })
            .catch(err => {
                console.log(err)
            })
        },

        getMousePos(e) {
            const canvas = this.viewer.renderer.domElement
            let rect = canvas.getBoundingClientRect()
            let scaleX = canvas.width / rect.width
            let scaleY = canvas.height / rect.height
            return [
                (e.clientX - rect.left) * scaleX,
                (e.clientY - rect.top) * scaleY
            ]
        },

        pointInPolygon(point, polygon) {
            let x = point[0]
            let y = point[1]
            let inside = false

            for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
                let xi = polygon[i][0]
                let yi = polygon[i][1]
                let xj = polygon[j][0]
                let yj = polygon[j][1]
                let intersect = ((yi > y) !== (yj > y)) &&
                                (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
                if (intersect) inside = !inside
            }

            return inside
        },

        openPopup() {
            this.popupIsOpen = true
            this.introVisible = false
            this.$nextTick(() => this.$refs.pledgeInput.focus())
        },

        shuffle(array) {
            var currentIndex = array.length, temporaryValue, randomIndex
            while (0 !== currentIndex) {
                randomIndex = Math.floor(Math.random() * currentIndex)
                currentIndex -= 1
                temporaryValue = array[currentIndex]
                array[currentIndex] = array[randomIndex]
                array[randomIndex] = temporaryValue
            }
            return array
        },

        addInfospot(opts) {
            // let flagSize = (opts.myFlag) ? 100 : 74
            let flagSize = 74
            let y = opts.y
            let x = opts.x
            let z = opts.z
            if (opts.distance === 'foreground') {
                flagSize *= 2
            }
            else if (opts.distance === 'midground') {
                flagSize *= 1.5
            }
            // else if (opts.distance === 'background') {
            // }
            y += flagSize / 2

            let color = opts.color || 'white'
            let text = opts.text || ''

            console.log(`${this.rootDomain}/images/flags/flag-${color}.png`)

            const infospot = new PANOLENS.Infospot( flagSize, `${this.rootDomain}/images/flags/flag-${color}.png`)
            // rewrite setText method to allow html
            infospot.setText = function (text) {
                if ( this.element ) {
                    this.element.innerHTML = text;
                }
            }

            infospot.position.set( x, y, z )
            infospot.addHoverText( text, 60 )
            this.panorama.add(infospot)
            this.infospots.push(opts)
            this.panorama.toggleInfospotVisibility(true)
            // return true
        },

        onEnter() {
            this.$refs.progress.style.width = 0
            this.$refs.progress.classList.remove( 'finish' )
        },

        onProgress(event) {
            let progress = event.progress.loaded / event.progress.total * 100
            this.$refs.progress.style.width = progress + '%'
            if ( progress >= 100 ) {
                this.loaded = true
                this.$refs.loadmask.style.display = 'none'
                this.$refs.loadmask.parentNode.removeChild(this.$refs.loadmask)
                this.$refs.progress.style.width = 0
            }
        },

        
    },

}
</script>


<style lang="scss">
  @import './panolens.scss'; 
</style>
